import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, RendererFactory2, ViewEncapsulation } from '@angular/core';
import { Link } from '@app/entities/link';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private rendererFactory: RendererFactory2,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(DOCUMENT) private document: any
  ) { }

  public createLinkForCanonicalURL(): void {
    this.removeTag('rel=canonical');
    this.addTag({ rel: 'canonical', href: this.document.URL.replace('http', 'https') });
  }

  private addTag(tag: Link, forceCreation?: boolean): void {
    try {
      const renderer = this.rendererFactory.createRenderer(this.document, {
        id: '-1',
        encapsulation: ViewEncapsulation.None,
        styles: [],
        data: {}
      });
      const link = renderer.createElement('link');
      const head = this.document.head;
      if (head === null) {
        return;
      }
      Object.keys(tag).forEach((prop: string) => {
        return renderer.setAttribute(link, prop, tag[prop]);
      });
      renderer.appendChild(head, link);

    } catch (e) {
    }
  }

  private removeTag(attrSelector: string): void {
    if (attrSelector) {
      try {
        const renderer = this.rendererFactory.createRenderer(this.document, {
          id: '-1',
          encapsulation: ViewEncapsulation.None,
          styles: [],
          data: {}
        });
        const head = this.document.head;
        if (head === null) {
          return;
        }
        const linkTags = this.document.querySelectorAll(`link[${attrSelector}]`);
        for (const link of linkTags) {
          renderer.removeChild(head, link);
        }
      } catch (e) {
      }
    }
  }
}
